import { EnvironmentProviders, inject, makeEnvironmentProviders, provideAppInitializer } from '@angular/core'

import { TRANSLATIONS } from './translations.token'
import { TranslationsLoaderService } from './translations-loader.service'
import { TranslatorService } from './translator.service'

/**
 * loads the translations with the {@link TranslationsLoaderService} AND provides the {@link TranslatorService}.
 * Registers an {@link APP_INITIALIZER} with the loading promise.
 */
export function provideTranslator(): EnvironmentProviders {
  return makeEnvironmentProviders([
    TranslationsLoaderService,
    provideAppInitializer(() => {
      const initializerFn = (() => inject(TranslationsLoaderService).load)()
      return initializerFn()
    }),
    // we use this additional abstraction to easily mock it for testing
    { provide: TRANSLATIONS, useFactory: () => inject(TranslationsLoaderService).translations },
    TranslatorService,
  ])
}
